<template>
    <div>
        <v-container class="px-0 py-0 locale-font">
            <v-row no-gutters>
                <v-col cols="5">
                    <v-col cols="10">
                        <span class="condition">
                            {{ $vuetify.lang.t('$vuetify.employeeImportImage.conditionImport') }}
                        </span>

                        <div class="mt-3">
                            <li class="condition-desc">
                                {{ $vuetify.lang.t('$vuetify.employeeImportImage.firstImportCondition') }}
                            </li>
                            <li class="condition-desc">
                                {{ $vuetify.lang.t('$vuetify.employeeImportImage.secondImportCondition') }}
                            </li>
                            <li class="condition-desc">
                                {{ $vuetify.lang.t('$vuetify.employeeImportImage.thirdImportCondition') }}
                            </li>
                        </div>
                    </v-col>
                </v-col>
                <v-col cols="7">
                    <div class="upload-header">
                        {{ $vuetify.lang.t('$vuetify.employeeImportList.uploadFile') }}
                    </div>
                    <div class="upload-subheader mt-2">
                        {{ $vuetify.lang.t('$vuetify.employeeImportImage.shouldBeZip') }}
                    </div>
                    <div
                        @dragover="dragOver"
                        @dragleave="dragLeave"
                        @dragstart.prevent="drag"
                        @dragover.prevent
                        @drop.prevent
                        @drop="drop"
                        class="upload-excel-card">
                        <div
                            class="disabled-drag-area">
                            <div class="d-flex-center">
                                <img
                                    :class="classDragged"
                                    src="@/assets/employee/import-zip.png">
                            </div>
                            <div>
                                <span class="drag-drop-text">
                                    {{ $vuetify.lang.t('$vuetify.employeeImportList.dragDrop') }}
                                </span>
                                <span
                                    :class="onDrag"
                                    @click="selectFile()"
                                    class="browse-text">
                                    {{ $vuetify.lang.t('$vuetify.employeeImportList.browse') }}
                                </span>

                                <input
                                    ref="browseFile"
                                    type="file"
                                    class="browse-file"
                                    accept="application/x-rar-compressed, application/zip, application/x-zip-compressed, multipart/x-zip"
                                    @change="onSelectFile">
                            </div>
                        </div>
                    </div>
                    <div v-if="uploadFiles.length > 0">
                        <div class="uploaded-file-header">
                            {{ $vuetify.lang.t('$vuetify.employeeImportList.uploadedFile') }}
                        </div>
                        <upload-file
                            v-for="(uploadFile, indexUploadFile) in uploadFiles"
                            :key="indexUploadFile"
                            :name="uploadFile.name"
                            :loadingPercent="uploadFile.loadingPercent"
                            :isSuccess="uploadFile.isSuccess"
                            :typeFile="uploadFile.typeFile"/>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <import-employee-result-modal
            ref="importEmployeeResultModal"
            :title="importResult.title"
            :content="importResult.content"
            :result="importResult.result" />
    </div>
</template>

<script>
import EmployeeImportMixin from '@/mixins/components/EmployeeImportMixin'
export default {
    name: 'EmployeeImportImage',

    props: {
        branchId: {
            type: Number,
            default: null
        }
    },

    mixins: [EmployeeImportMixin],

    methods: {
        showUploadResult (data) {
            const result = data.result
            delete data.result
            this.importResult = {
                title: this.$vuetify.lang.t('$vuetify.employeeImportImage.importResult'),
                content: data,
                result: result
            }

            this.$refs.importEmployeeResultModal.showModal()
        },

        isZipFile (typeFile) {
            const rarType = 'application/x-rar-compressed'
            const zipType = 'application/zip'
            const zipCompressedType = 'application/x-zip-compressed'
            const xZipType = 'multipart/x-zip'
            if (typeFile === rarType || typeFile === zipType || typeFile === zipCompressedType || typeFile === xZipType) {
                return true
            }
            return false
        },

        async drop (event) {
            this.isDrag = false
            const droppedFiles = event.dataTransfer.files

            // check amount of uploading file and cannot upload while uploading
            if (droppedFiles.length > 1 && this.isUploading === true) {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.employeeImportList.uploadOneFile'))
            }

            // check file type
            if (droppedFiles[0] && this.isZipFile(droppedFiles[0].type)) {
                this.file = droppedFiles[0]
                await this.uploadFile()
            } else {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.employeeImportList.wrongFileFormat'))
            }
        },

        async uploadFile () {
            this.$store.dispatch('setLoading', true)

            this.isUploading = true
            const toUploadFile = {
                name: this.file.name,
                loadingPercent: 0,
                typeFile: 'zip',
                isSuccess: true
            }
            this.uploadFiles.unshift(toUploadFile)

            const formData = new FormData()
            formData.append('branch', this.branchId)
            formData.append('file', this.file)

            const url = 'import/employee-face'
            const config = {
                headers: { 'Content-Type': 'application/form-data' },
                onUploadProgress: progressEvent => {
                    this.uploadFiles[0].loadingPercent = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                }
            }
            const res = await this.axios.post(url, formData, config)

            if (res && res.data) {
                if (res.data.status === 'ok' && res.data.errors && res.data.data) {
                    // for validation failed
                    this.uploadFiles[0].isSuccess = false
                    this.showUploadResult(res.data.data)
                } else if (res.data.status === 'ok' && res.data.data) {
                    this.uploadFiles[0].isSuccess = true
                    this.showUploadResult(res.data.data)
                } else {
                    this.uploadFiles[0].isSuccess = false
                }
            }

            this.$refs.browseFile.value = null
            this.isUploading = false
            this.$store.dispatch('setLoading', false)
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-header, .condition {
    font-size: 18px;
    font-weight: bold;
}
.condition-desc {
    color: #6c6c6c;
}
.upload-subheader {
    color: #6c6c6c;
}
.upload-excel-card {
    margin-top: 1.5rem;
    width: 500px;
    height: 250px;
    border-radius: 20px;
    border: dashed 2px #6c98ba;
    background-color: #f6f9fb;
    display: flex;
    justify-content: center;
    align-items: center;
}
.drag-drop-text {
    color: #a8a8a8;
}
.browse-text {
    color: #d76436;
    text-decoration: underline;
    cursor: pointer;
    pointer-events: all;
}
.big-image {
    width: 120px;
}
.browse-file {
    display: none;
}

.disabled-drag-area {
    width: 100%;
    height: 100%;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.uploaded-file-header {
    margin-top: 1rem;
    font-size: 18px;
    font-weight: bold;
}
.on-drag {
    pointer-events: none;
}
</style>
